import React from 'react'

import { Box, Grid, LinearProgress, Typography } from "@mui/material"


export default function searchesColumn() {

	return {
		name: 'searches',
		label: 'Number of searches',
		render: (value, { percentage }) => <Grid container spacing={2}>
			<Grid item xs={3}/>
			<Grid item xs={6} sx={{ display: "inline-flex", alignItems: "center" }}>
				<Box sx={{ width: '70%', mr: 1 }}>
					<LinearProgress variant="determinate" value={Math.abs(percentage)}/>
				</Box>
				<Typography sx={{ fontWeight: "bold", color: "secondary.main" }}>{value}</Typography>
			</Grid>
			<Grid item xs={3}/>
		</Grid>
	}
}